module.exports = ".dropdown-toggle:after {\n  display: none; }\n\n.no-padding [class*=\"col-\"] {\n  margin: 0 !important;\n  padding: 0 !important; }\n\n.dropdown-item {\n  cursor: pointer;\n  font-weight: 450; }\n\n.dropdown-item:hover, .dropdown-item:active {\n    background: #e6e5e5; }\n\n.dropdown-item:focus {\n    color: black; }\n\n.btn-big {\n  font-size: 1rem;\n  font-weight: 450; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/filter-button/filter-button.component.scss
// module id = ./src/app/shared/components/filter-button/filter-button.component.scss
// module chunks = main